import type { PublicSlotKey } from '#packages/apilib';
import type { ZoomModeApi } from './api';

export const ZoomModeApiKey: PublicSlotKey<ZoomModeApi> = {
  name: 'ZoomModeApi',
  public: true,
};
